export enum UserTaskExportTaskSort {
	CREATION = 'CREATION',
	DUE = 'DUE',
	USER_NAME = 'USER_NAME',
	EXPORTED_TASKS_STATUS = 'EXPORTED_TASKS_STATUS',
	PARTICIPANT_NAME = 'PARTICIPANT_NAME',
}
